module.exports = __webpack_public_path__ + "img/official__back.c67f228d.jpg";